import _ from 'lodash';
import dateFormat from './dateFormat';

// 文档地址
// https://github.com/ali-sdk/ali-oss?spm=5176.doc32068.2.1.KgGUD6#browser-usage
// https://help.aliyun.com/document_detail/32068.html
function execute(file, dir, timestamp) {
    const client = new window.OSS.Wrapper({
        region: 'oss-cn-shenzhen',
        accessKeyId: 'LTAI4GHjDnXpCCt3DKijMnrE',
        accessKeySecret: 'iryOWfjowrdXvAsQZnyQk7aBOHeCFq',
        bucket: 'xuansiwei-cdn'
    });
    const day = dateFormat(new Date(), "yyyy-MM-dd");
    return client.multipartUpload(`ordersystem/${day}/${dir}/${timestamp}/${file.name}`, file)
        .then(res => {
            console.info('res:', res);
            return {
                url: `http://cdn.xuansiwei.com/ordersystem/${day}/${dir}/${timestamp}/${file.name}`,
                filename: file.name
            };
        });
}

function compress(img) {
    //    用于压缩图片的canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext('2d');
    //    瓦片canvas
    const tCanvas = document.createElement("canvas");
    const tctx = tCanvas.getContext("2d");
    const initSize = img.src.length;
    let width = img.width;
    let height = img.height;
    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    let ratio = (width * height) / 4000000;
    if (ratio > 1) {
      ratio = Math.sqrt(ratio);
      width /= ratio;
      height /= ratio;
    } else {
      ratio = 1;
    }
    canvas.width = width;
    canvas.height = height;
//        铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片像素大于100万则使用瓦片绘制
    let count = (width * height) / 1000000;
    if (count > 1) {
      count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
//            计算每块瓦片的宽和高
      const nw = ~~(width / count);
      const nh = ~~(height / count);
      tCanvas.width = nw;
      tCanvas.height = nh;
      for (let i = 0; i < count; i++) {
        for (let j = 0; j < count; j++) {
          tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
          ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
        }
      }
    } else {
      ctx.drawImage(img, 0, 0, width, height);
    }
    //进行最小压缩
    const ndata = canvas.toDataURL('image/jpeg', 0.1);
    console.log(`压缩前：${initSize}`);
    console.log(`压缩后：${ndata.length}`);
    console.log(`压缩率：${~~((100 * (initSize - ndata.length)) / initSize)}%`);
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
}
function fileToImage(file) {
    return new Promise((resolve)=>{
        const img = new window.Image();
        img.onload = function () {
            resolve(img);
        };
        img.src = window.URL.createObjectURL(file);
    })
}
/**
 * 获取blob对象的兼容性写法
 * @param buffer
 * @param format
 * @returns {*}
 */
function getBlob(buffer, format) {
    try {
        return new window.Blob(buffer, {type: format});
    } catch (e) {
        const bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)();
        buffer.forEach((buf) => {
            bb.append(buf);
        });
        return bb.getBlob(format);
    }
}
function imgStrToBlob(basestr, type) {
    const text = window.atob(basestr.split(",")[1]);
    const buffer = new Uint8Array(text.length);
    for (let i = 0; i < text.length; i++) {
      buffer[i] = text.charCodeAt(i);
    }
    const blob = getBlob([buffer], type);
    return blob;
}
export function uploadImg(dir = '/', fileId = 'file-id') {
    const files = document.getElementById(fileId).files;
    const timestamp = `${new Date().getTime()}`;
    if (files.length > 1) {
        return Promise.all(_.map(files, (file)=>{
            return fileToImage(file)
                .then((img)=>{
                    const imgStr = compress(img);
                    return execute(file.name, imgStrToBlob(imgStr, file.type), dir, timestamp);
                })
            
        }))
    }
    return execute(files[0], dir, timestamp)
}

export default (dir = '/', fileId = 'file-id') => {
    const files = document.getElementById(fileId).files;
    const timestamp = `${new Date().getTime()}`;
    if (files.length > 1) {
        return Promise.all(_.map(files, (file)=>{
            return execute(file, dir, timestamp);
        }))
    }
    return execute(files[0], dir, timestamp)
}


// WEBPACK FOOTER //
// ./src/util/ossUpload.js